export default function onlyForDistributorUser({ next, store }) {
    const isDistUser = store.getters['user/isDistUser'];
    if (isDistUser) {
        return next();
    }
    return next({
        name: 'Login',
    });
}
